<template>
    <div class="our-projects">
        <div class="content">
				<div class="title fadeIn animated">
					<h1>Our Projects</h1>
					<p>Some of the brands we love (and they love us back)</p>
				</div>
				<div class="grid fadeIn animated">

					<div v-for="(project, index) of projects" :key="index" :project="index" :class="['grid__item','fadeIn','animated','easeOutCubic']" :data-size="sizes[index]" @click="currentProject(project)">							
						<a :href="'../assets/images/original/'+project+'.jpg'" class="img-wrap" @click="stopLink">
							<img :src="'./assets/images/thumbs/'+project+'.jpg'" alt="the360.agency" />
							<div class="description description--grid"></div>
						</a>
					</div>

				</div>
				<div class="preview">
					<button class="action action--close"><i class="fas fa-times"></i></button>
					<div class="description description--preview">
						<div class="grid__nav">
							<div class="arrow prev" @click="navAction('prev')"><i class="fas fa-chevron-left"></i></div>
							<div class="arrow next" @click="navAction('next')"><i class="fas fa-chevron-right"></i></div>
						</div>
					</div>
				</div>

				   <div class="sources" v-if="load">
						<div v-for="(project, index) of projects" :key="index">
							<img :src="'./assets/images/original/'+project+'.jpg'" alt="the360.agency" />
						</div>
					</div>

			</div>
    </div>
</template>

<script>
import $ from 'jquery'
import { setTimeout } from 'timers';
export default {
	name: 'our-projects',
	data: function(){
		return{
			index: 0,
			current: 0,
			load: true,
			projects :[43,36,41,40,39,38,37,42,35,34,33,32,31,1,5,6,9,10,2,11,12,13,14,15,8,16,17,7,18,19,3,4,20,21,22,29,23,24,25,26,28,30],
			sizes: ['840x1280','1280x850','840x1280','1280x850','840x1280','1280x850','840x1280','1280x850','1280x850','840x1280','1280x850','840x1280','1280x1130','840x1280','1280x850','840x1280','1280x850','1280x1130','840x1280','1280x850','1280x1130','1280x850','1280x1130','1280x850','840x1280','1280x1130','1280x850','840x1280','1280x850','1280x1130','840x1280','840x1280','1280x850','1280x1130','1280x850','840x1280','1280x850','1280x1130','1280x850','840x1280','1280x1130','1280x850']
		}
	},
  created(){
		$.getScript("../assets/js/grid.js");

		setTimeout(() => {
			this.load = false;
		}, 3000);
	},
	methods: {
		stopLink(e){
			e.preventDefault();
			return false;
		},
		currentProject(current){
			this.current = current;
		},
		navAction(nav){
			if(this.current == null) this.current = 0;
			let move = this.current;
			if(nav == 'prev'){
				move --;
				if(move < 1){
					move = this.projects.length;
				}
			}else if(nav == 'next'){
				move ++;
				if(move > this.projects.length){
					move = 1;
				}
			}
			this.current = move;
			$('.our-projects').find('.preview').find('.original').attr('src','../assets/images/original/'+move+'.jpg');
			$('.our-projects').find('.preview').find('.clone').attr('src','../assets/images/thumbs/'+move+'.jpg');
		}
	}
}
</script>